import { FlashMessageContainer, Content, Close, InnerContent } from './styles';

function FlashMessage(props) {
  const { timeout } = props;

  if (!props.visible) {
    return null;
  }

  if (timeout !== -1) {
    setTimeout(() => {
      if (props.visible && props.onClose) {
        props.onClose();
      }
    }, timeout);
  }

  return (
    <FlashMessageContainer className={props.className}>
      {/* @ts-expect-error TS(2769): No overload matches this call. */}
      <Content type={props.type}>
        <InnerContent>{props.text}</InnerContent>
        {props.onClose && (
          <Close data-testid="flash-message__close" onClick={props.onClose} className="icon-close-light" />
        )}
      </Content>
    </FlashMessageContainer>
  );
}

FlashMessage.defaultProps = {
  className: undefined,
  type: null,
  onClose: null,
  timeout: 3000,
};

export default FlashMessage;
